/**
 * Show error message to input text.
 * 
 * @param {HTMLElement} dom - HTMLElement Field input.
 * @param {string} msg - Error message.
 */
const showError = (dom, msg) => {
  const el = document.createElement('span');
  el.classList.add('error');
  el.innerHTML = msg;

  dom.after(el);
};

export default showError;
